<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M6.667 6.557v8.647h15.399l2.83-4.323-2.83-4.324H6.667zm9.827-2V3.352a.597.597 0 00-.591-.602h-2.366a.597.597 0 00-.591.602v1.205H6.441c-.98 0-1.774.809-1.774 1.807v9.034c0 .998.794 1.806 1.774 1.806h6.505v11.444c0 .332.265.602.591.602h2.366c.326 0 .591-.27.591-.602V17.204h5.703c.594 0 1.148-.301 1.477-.804l3.394-5.185a.612.612 0 000-.668L23.673 5.36a1.766 1.766 0 00-1.476-.804h-5.703z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'objectsSignOutline'
}
</script>
